import React, { useState, useEffect } from 'react';
import './news.css';
// import "../../../src/App.css";
import { HiCurrencyRupee } from "react-icons/hi";
import Helper from "../../helper";
import Appconfig from '../../config/config'
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const ExposureHeader = () => {
  const userInfo = Helper();
  const betData = useSelector((state) => state.data); // Use selector to access state
  const navigate = useNavigate();

  const [news, setNews] = useState("");
  const [balance, setBalance] = useState(0)
  const [exposure, setExposure] = useState(0)
  let balanceWithExp = balance - Math.abs(exposure);

  const navigateTo = (path) => {
    navigate(path);
  };


  useEffect(() => {
    if (userInfo) {
      getBalance();
    }
  }, [userInfo, betData])

  function getBalance() {
    var data = JSON.stringify({
      user_id: userInfo?._id,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}ledger/getUserBalance`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result == 0) {
        } else {
          setBalance(response.data.resultData?.balance)
          setExposure(response.data.resultData?.exposure)
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const now = new Date();
  const date = now.toLocaleDateString();     // e.g., 16/07/2025
  const time = now.toLocaleTimeString();

  function getNews() {
    var data = JSON.stringify({
      site_id: userInfo?.master_id,
    });

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}news/getNews`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.result == 0) {
        } else {
          // setBalance(response.data.resultData?.balance)
          // setExposure(response.data.resultData?.exposure)
          console.log('news response', response?.data?.resultData);
          setNews(response?.data?.resultData);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  useEffect(() => {
    if (userInfo) {
      getBalance();
      getNews();
    }
  }, [userInfo, betData])



  return (
    // <div className="exposure-header-wrapper">
    //   <div className="main-header">
    //     <div className="coin">
    //       <HiCurrencyRupee size={20} color=" #FFD700" style={{ marginRight: 5, marginLeft: 0, marginTop: 1 }} />
    //     </div>
    //     {userInfo ? (
    //       <>
    //         <span className='main-balance'>
    //           Main: <p>{balance && Number(balanceWithExp).toFixed(2)}</p>
    //         </span>
    //         <span className='exposure-balance' onClick={() => navigateTo('/openbets')}>
    //           Exposure: <p>{exposure && Number(exposure).toFixed(2)}</p>
    //         </span>
    //       </>
    //     ) : (
    //       <span className='main-balance'>
    //         Please login to see your balance
    //       </span>
    //     )}
    //   </div>
    // </div>
    <>
      {news && news?.length > 0 && (
        <div className={`withdraw-bg-color w-full h-[32px] ${userInfo ? "hide bg-gradient-to-b from-cyan-300 to-cyan-900" : "block bg-[#045662]"} `} style={{ height: "25px", }}>
          <div className="flex items-center justify-center" style={{ display: "flex", alignItems: "center", height: "32px" }}>
            {
              !userInfo && (
                <div className="flex items-center w-[32px] h-[25px]" style={{ width: "32px", height: "25px", display: "flex", alignItems: "center" }}>

                  <span>
                    <svg class="fa fa-bullhorn" xmlns="http://www.w3.org/2000/svg" fill="white" width="12px" className='ml-2 mb-1' viewBox="0 0 512 512"><path d="M480 32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9L381.7 53c-48 48-113.1 75-181 75l-8.7 0-32 0-96 0c-35.3 0-64 28.7-64 64l0 96c0 35.3 28.7 64 64 64l0 128c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-128 8.7 0c67.9 0 133 27 181 75l43.6 43.6c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-147.6c18.6-8.8 32-32.5 32-60.4s-13.4-51.6-32-60.4L480 32zm-64 76.7L416 240l0 131.3C357.2 317.8 280.5 288 200.7 288l-8.7 0 0-96 8.7 0c79.8 0 156.5-29.8 215.3-83.3z" /></svg>

                  </span>
                </div>
              )
            }
            <marquee
              behavior="scroll"
              scrollamount="4"
              className="text-[#fff] text-xs uppercase w-full mt-[-8px]"
            >
              {/* WELCOME TO REDDY ANNA BIGGEST ONLINE BOOK OF INDIA...PAYMENT GATEWAY AVAILABLE FOR INSANT DEPOSIT */}
              {news?.map((n, index) => (
                <span key={index} className="mr-6 ">
                  {n.message}
                </span>
              ))}
            </marquee>
            <div className={` w-[99px] h-[25px] ${userInfo ? "hidden" : "block"}`}>
              <div className="flex space-x-1 text-[12px] text-white">
                <span>{date}</span>
                <span>{time}</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ExposureHeader;